import * as React from "react";
import DebtWidgetComparison from "./DebtWidgetComparison";
import SectionHeading from "src/components/general/SectionHeading";


/*
 *	Displays a static image with text below depicting government debt
 */

class StateFederalDebtComparison extends React.PureComponent {

  public render() {
    
    return (
    	<div>
    		<div className="text-center">
    			<div className="max-w-sm mx-auto mt-20">
	    			<SectionHeading
		            	heading="How do debt levels compare across the three levels of government?"
		            	alignment="center"
		            	inverse={ false }
		            	learnMore={ "governmentDebt" }
		          	/>
	          	</div>
	          	<p className="text-sm mb-12 max-w-md mx-auto">
	            All levels of government need to borrow money to build and maintain assets and to support and protect local communities.
	          	</p>
	        </div>
	      	<div className="flex flex-wrap">
		      	<div className="w-full md:w-1/3 mb-8 debt--commonwealth">
			      	<DebtWidgetComparison 
			      		title="Commonwealth borrowings"
			      		amount="21,284"
			      		text="per capita"
			      	/>
		      	</div>
		      	<div className="w-full md:w-1/3 mb-8 debt--qld-state">
			      	<DebtWidgetComparison 
			      		title="Queensland State Government borrowings"
			      		amount="13,362"
			      		text="per capita"
			      	/>
		      	</div>
		      	<div className="w-full md:w-1/3 mb-8 debt--qld-local">
			      	<DebtWidgetComparison 
			      		title="Queensland local Government borrowings"
			      		amount="1,225"
			      		text="per capita"
			      	/>
		      	</div>
		    </div>
    	</div>
    );

  }
}

export default StateFederalDebtComparison;



// WEBPACK FOOTER //
// ./src/components/report/councilFinances/StateFederalDebtComparison.tsx